import React, { ChangeEvent, TextareaHTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export type TextAreaProps = Omit<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  'onChange' | 'value' | 'onBlur'
> & {
  className?: string
  value: string | undefined
  onChange: (value: string) => void
  onBlur?: (value: string) => void
  removeWhitespaces?: boolean
}

export const TextArea = ({
  onChange,
  onBlur,
  value,
  className,
  removeWhitespaces,
  ...props
}: TextAreaProps) => {
  const getValue = (e: ChangeEvent<HTMLTextAreaElement>) => {
    return removeWhitespaces
      ? e.target.value.replace(/\s/g, '')
      : e.target.value
  }

  return (
    <label
      htmlFor={props.id}
      className={twMerge(
        'flex w-full items-center overflow-hidden rounded-md border border-border200 px-3 py-2.5',
        className,
      )}
    >
      <textarea
        className={twMerge(
          'h-auto min-h-[4em] w-full border-none p-0',
          'appearance-none [-moz-appearance:textfield] focus:border-none focus:outline-none',
          '[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none',
        )}
        onChange={e => {
          onChange(getValue(e))
        }}
        onBlur={e => {
          onBlur?.(getValue(e))
        }}
        value={value ?? ''}
        {...props}
      />
    </label>
  )
}
